module.exports = __webpack_public_path__ + "img/exchange.443cdb76.svg";